// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3XZww","author":"Table_author__2NhGy","authorImage":"Table_authorImage__B-NZA","unreadRow":"Table_unreadRow__Dkmwv"};